__turbopack_context__.v({
  "backdrop": "SiteShowcase-module__1P2Yda__backdrop",
  "card": "SiteShowcase-module__1P2Yda__card",
  "frame": "SiteShowcase-module__1P2Yda__frame",
  "grid": "SiteShowcase-module__1P2Yda__grid",
  "head": "SiteShowcase-module__1P2Yda__head",
  "inner": "SiteShowcase-module__1P2Yda__inner",
  "meta": "SiteShowcase-module__1P2Yda__meta",
  "name": "SiteShowcase-module__1P2Yda__name",
  "nav": "SiteShowcase-module__1P2Yda__nav",
  "navButton": "SiteShowcase-module__1P2Yda__navButton",
  "section": "SiteShowcase-module__1P2Yda__section",
  "set": "SiteShowcase-module__1P2Yda__set",
  "shot": "SiteShowcase-module__1P2Yda__shot",
  "stage": "SiteShowcase-module__1P2Yda__stage",
  "track": "SiteShowcase-module__1P2Yda__track",
});
